import { useContext, useState } from 'react';

import { Checkbox, useTheme } from '@mui/material';

import { ForwardMessageContext } from '../../context/ForwarMessage/ForwardMessageContext';

const SelectMessageCheckbox = ({ message }) => {
  const theme = useTheme();
  const [isChecked, setIsChecked] = useState(false);
  const { showSelectMessageCheckbox, setSelectedMessages, selectedMessages } =
    useContext(ForwardMessageContext);

  const handleSelectMessage = (e, message) => {
    const list = selectedMessages;
    if (e.target.checked) {
      setIsChecked(!isChecked);
      list.push(message);
    } else {
      const index = list.findIndex((m) => m.id === message.id);
      list.splice(index, 1);
      setIsChecked(!isChecked);
    }
    setSelectedMessages(list);
  };

  if (showSelectMessageCheckbox) {
    return (
      <Checkbox
        checked={isChecked}
        onChange={(e) => handleSelectMessage(e, message)}
        sx={{
          marginRight: '3px',
          padding: 0,
          color: theme.custom.colors.text,
          '&.Mui-checked': { color: theme.custom.colors.text },
        }}
      />
    );
  } else {
    return null;
  }
};

export default SelectMessageCheckbox;
